import axios from 'axios'
import { getGraphURL } from '../../../../utils/getServiceUrl'
import { APOLLO_CLIENT_NAME } from '@mfs/client/common/constants/constants'
import { get } from 'lodash'

const query = `
query airDynamicFilters($input: AirSearchReq) {
    airDynamicFilters(input: $input) {
        filters {
          type
          display
          image
          filterId
        }
    }
  }
`

export const getDynamicFilterChips = ({ request, skipPclnGraph }) => {
  const { useLocalFlyql } = window.PCLN_BOOTSTRAP_DATA || {}
  const headers = {
    'apollographql-client-name': `${APOLLO_CLIENT_NAME}`,
    'apollographql-client-version': get(window, 'PCLN_BOOTSTRAP_DATA.appInfo.appVersion', 'development'),
  }

  return new Promise((resolve, reject) => {
    axios({
      url: getGraphURL({ skipPclnGraph, operationName: 'airDynamicFilters', useLocalFlyql }),
      method: 'post',
      data: {
        query: query,
        variables: request,
      },
      headers,
    })
      .then((response) =>
        response.data.data.airDynamicFilters.filters.filter((elm) => elm.type !== 'DURATION')
      )
      .then((filteredData) => resolve(filteredData))
      .catch((error) => {
        reject(error)
      })
  })
}
